import type * as React from "react";
import { cn } from "@/lib/utils";

interface DashboardLayoutProps {
	children: React.ReactNode;
	className?: string;
}

function DashboardLayout({ children, className }: DashboardLayoutProps) {
	return (
		<main
			data-dashboard-scroll-container
			className={cn("min-w-0 flex-1 overflow-y-auto", className)}
		>
			{children}
		</main>
	);
}

interface DashboardContentProps {
	children: React.ReactNode;
	className?: string;
}

function DashboardContent({ children, className }: DashboardContentProps) {
	return (
		<div
			className={cn(
				"mx-auto w-full max-w-none px-4 py-8 sm:px-6 lg:px-8 xl:max-w-[1800px]",
				className,
			)}
		>
			{children}
		</div>
	);
}

interface DashboardHeaderSectionProps {
	children: React.ReactNode;
	className?: string;
	contentClassName?: string;
}

function DashboardHeaderSection({
	children,
	className,
	contentClassName,
}: DashboardHeaderSectionProps) {
	return (
		<section
			className={cn(
				"border-b border-sidebar-border bg-sidebar dark:bg-background sm:min-h-[119px]",
				className,
			)}
		>
			<div
				className={cn(
					"mx-auto flex w-full max-w-none flex-col justify-center px-4 py-7 sm:min-h-[119px] sm:px-6 lg:px-8 xl:max-w-[1800px]",
					contentClassName,
				)}
			>
				{children}
			</div>
		</section>
	);
}

export { DashboardLayout, DashboardContent, DashboardHeaderSection };
